/** ISO-veckonummer – det El-kretsen säger i vardagen ("vecka 41"). */
export function veckonummer(isoDatum: string): number {
  const d = new Date(`${isoDatum}T00:00:00Z`);
  // Torsdagen i samma vecka avgör vilket år veckan hör till.
  d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
  const arStart = Date.UTC(d.getUTCFullYear(), 0, 1);
  return Math.ceil(((d.getTime() - arStart) / 86_400_000 + 1) / 7);
}
